import { AfterViewInit, Directive, ElementRef, HostBinding, Input, OnDestroy, inject } from '@angular/core';
import { TutorialService } from './tutorial.service';

@Directive({ selector: '[appTutorialAnchor]', standalone: true })
export class TutorialAnchorDirective implements AfterViewInit, OnDestroy {
  @Input('appTutorialAnchor') anchorId = '';
  @HostBinding('attr.data-tutorial-anchor') get tutorialAnchor(): string { return this.anchorId; }
  private readonly element = inject(ElementRef<HTMLElement>);
  private readonly tutorial = inject(TutorialService);

  ngAfterViewInit(): void { this.tutorial.registerAnchor(this.anchorId, this.element.nativeElement); }
  ngOnDestroy(): void { this.tutorial.unregisterAnchor(this.anchorId); }
}
